module.exports = __webpack_public_path__ + "static/redime-tus-puntos-4-278e530d7ab399b2899ff6387fec1ffb.webp";